import { render, staticRenderFns } from "./parents_data.vue?vue&type=template&id=9a226a80&"
import script from "./parents_data.vue?vue&type=script&lang=js&"
export * from "./parents_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports